export interface IDashboardWidget {
    UpdateState(CardID:number, HiddenTF:boolean, DisplayOrder:number);
}

export abstract class DashboardWidget implements IDashboardWidget {
    public compInteraction: IDashboardWidget;
    public index: number;

    UpdateState(CardID:number, HiddenTF:boolean, DisplayOrder:number) {
        this.compInteraction.UpdateState(CardID, HiddenTF, DisplayOrder);
    }
}